import React, { useState, useEffect } from "react";
import { ReactComponent as RightArrow } from "../assets/arrow-right.svg";
import TextTransition, {
  presets,
} from "react-text-transition";

const TEXTS = ["Front-end", "Freelance"];

const Banner = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    let intervalId = setInterval(
      () => setIndex((index) => index + 1),
      2000
    );

    return () => {
      clearTimeout(intervalId);
    };
  }, [index]);

  return (
    <section className="main slide">
      <div className="container">
        <div className="row">
          <h2>
            <div className="line">
              <span role="img" aria-label="waving hand">
                Hi 👋, I am Vishal
              </span>
            </div>
            <div className="line">
              <span>
                <span>
                  <TextTransition
                    inline
                    text={TEXTS[index % TEXTS.length]}
                    springConfig={presets.gentle}
                  />
                </span>{" "}
                developer.
              </span>
            </div>
          </h2>
          <p>
            I specialize in efficient React apps that just
            work across all platforms and browsers. I care
            deeply about building interfaces that are usable
            and pleasant for the most number of people
            possible.
          </p>

          <div className="btn-row no-select">
            <a href="https://drive.google.com/file/d/1jvhP0eq0q2kIYxKxtkpeLl2dDFI55k7z/view?usp=sharing">
              Download CV <RightArrow />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
